export default __webpack_public_path__ + "static/media/legs-v2.99f4570d.png";